module.exports = __webpack_public_path__ + "img/SES_210422350.a36cf548.jpg";